import { call, put, takeLatest } from "@redux-saga/core/effects";
import { TripDetailConstant } from "./TripDetailConstant";
import { TripDetailParser } from "./TripDetailParser";
import { TripDetailApiData } from "./TripDetailApi";
function* getTripDetailData({ payload }) {
  let {from_date,to_date,search_term, page, limit,trip_status} = payload;

  try {
    yield put({ type: TripDetailConstant.TRIP_DETAIL_REQUEST });
    const res = yield call(TripDetailApiData.getTripDetailApiData , {
      to_date,
      from_date,
      search_term,
      page,
      limit,
      trip_status,
    });
    console.log('res',res);
    const payload = TripDetailParser.getTripDetailParser(res);
      
    yield put({
      type: TripDetailConstant.TRIP_DETAIL_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: TripDetailConstant.TRIP_DETAIL_RESPONSE,
      payload: [],
    });
  }
}


export function* TripDetailDataSaga() {
  yield takeLatest(TripDetailConstant.TRIP_DETAIL_SAGA, getTripDetailData);
}
